<template>
    <div class="mm_body">
        <mmheader :mm-site-url="mm_site_url"></mmheader>
        <section class="pad-60">
	        <div class="container"  style="margin-top: 72px;">
                <div class="row max-680">
                    <flash-message autoHide variant="success"></flash-message>
                    <flash-message autoHide variant="danger"></flash-message>
                    <div v-show="login_errors" class="validate-warning-msg-login">{{ login_errors }}</div>
                    <h1 class="inner-page text_bebas mm-login-text text-center">Log In</h1>
                    <hr class="d-none">
                    <div class="mm-pad-30">
                        <form class="form-signin" @submit.prevent="onSubmit" autocomplete="off">
                            <div class="form-group">
                                <input 
                                    type="email"
                                    name="email"
                                    id="email"
                                    ref="email"
                                    v-validate="'required|email'" 
                                    v-model="email"
                                    class="form-control" 
                                    placeholder="Email"
                                    autocomplete="off">
                                    <div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
                            </div>
                            <div class="form-group">
                                <input 
                                    type="password" 
                                    name="password" 
                                    id="password"
                                    ref="password"
                                    v-validate="'required'" 
                                    v-model="password"
                                    class="form-control"
                                    placeholder="Password"
                                    autocomplete="off">
                                    <div v-show="verrors.has('password')" class="validate-warning-msg">{{ verrors.first('password') }}</div>
                            </div>
                            <div class="text-center pad-20 margin-bottom-20- pb-2">
                                <button type="submit" class="btn btn-lg btn-blue get-started-btn border-radius-20">{{ signin_value }}</button>
                            </div>
                        </form>
                        <p class="text-center">
                            <a href="javascript:void(0);" class="text-center" @click="isModalVisible = true" style="font-size: 16px;
    color: #002F42 !important;">I Forgot My Password</a>
                            <MmForgotPassword :isModalVisible="isModalVisible" @close="isModalVisible = false">
                            </MmForgotPassword>
                            <MmSuccessModal :mm-site-url="mm_site_url" :isSuccessModalVisible="isSuccessModalVisible" @close="isSuccessModalVisible = false">
                            </MmSuccessModal>
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <mmfooter :mm-site-url="mm_site_url"></mmfooter>
    </div>
</template>
<style scoped>
@import 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap';
.get-started-btn, .text-bebas-btn, .text_bebas, .mm_text_bebas h2, h3 {
    /* font-family: 'Roboto Condensed', sans-serif; */
}
.text_bebas {
    font-size: 19px !important;
}
.text_bebas {
    font-family: 'bebas-neue-pro', sans-serif;
}

.get-started-btn {
        font-family: "proxima-nova", Arial, verdana !important;
}
.mm-login-text {
    color: #002F42 !important;
    font-family: 'bebas-neue-pro', sans-serif;
}
.mm_body {
    font-size: 20px !important;
    max-width: 2400px;
    margin: auto;
}
.pad-60 {padding: 60px 0px;}
.pad-20 {padding: 20px;}
.max-680 {max-width: 560px; margin: auto;}
.margin-bottom-60 {margin-bottom: 60px;}
.margin-bottom-30 {margin-bottom: 30px;}
.margin-20 {margin: 20px 0px;}
.row {
    display: block;
}
/* Form input css start */
.form-group {
    margin-bottom: 8px;    
}
.form-control {height: 46px;}
.form-control {font-size: 18px; color: #000; /* background: #F5F5F5; */ }
.form-control:focus {
    border-color: #d3d3d3;
    /* box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); */
}
.validate-warning-msg {
    text-align: left;
    font-size: 16px;
}
/* Form input css stop */
/* button css start */
.btn-lg {padding: 14px 50px;}
.btn-blue {color: #fff;}
.btn {border-radius: 18px; border: none; font-size: 22px !important; font-weight: bold; font-style:  normal;}
.btn:hover, .btn:focus {color: #fff !important; text-decoration: underline; outline: 0 !important;}
/* button css stop */
/* anchor css start */
a { color: #00ACEE; cursor: pointer; font-size: 20px; }
a:focus, a:hover { color: #00ACEE; text-decoration: underline;}
a:hover {opacity: 0.9;}
/* anchor css stop */
/* heading css start */
h1 {
    color: #4B4B4B !important;
}
.h1, h1 {
    font-size: 36px !important;
}
.h1, .h2, .h3, h1, h2, h3 {
    margin-top: 20px;
    margin-bottom: 10px;
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
}
/* heading css stop */
hr {
    border-top: 1px solid #e3e3e3;
    margin-top: 20px;
    margin-bottom: 20px;
}
/* media query css start */
@media (max-width: 991px) {
    .pad-60 {padding: 60px 20px;}
}
@media (min-width: 1200px){
    .container {
        width: 1170px !important;
    }
}
@media (max-width: 320px) {
    .btn-lg { padding: 0.5rem 1rem; }
    .logo-main img { width: 160px; margin-top: -8px; }
}
/* media query css stop */
.mm-pad-30 {
    padding: 30px;
}
.get-started-btn {
    padding: 6px 69px;
    border-radius: 10px;
    font-size: 18px !important;
}
</style>
<script>
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import {login} from 'vuex';
import store from '../store/store.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

import mmheader from './mm_header';
import mmfooter from './mm_footer';
import MmForgotPassword from './mm_forgotpassword';
import MmSuccessModal from './mm_success_modal';

export default {
    data() {
        return {
            mm_site_url: process.env.MM_SITE_URL,
            signin_value: 'Log In',
            email: '',
            password: '',
            login_errors: '',
            isModalVisible: false,
            isSuccessModalVisible: false,
            roles: [],
            admin_role_flag: '',
            manager_role_flag: '',
            mentor_role_flag: '',
            mentee_role_flag: '',
            apprentice_role_flag: '',
            instructor_role_flag: '',
            student_role_flag: '',
            enterprise_admin_role_flag: '',
            researcher_role_flag: '',
            csr_role_flag: '',
            userAccounts: {
                isUserLinkedMultipleLocations: false,
                locations: [],
                current: {},
            },
            locationsCount: 0,
        }
    },
    components: {
        mmheader,
        mmfooter,
        MmForgotPassword,
        MmSuccessModal
    },
    methods: {
        onSubmit() {
            this.login_errors = '';
            this.$validator.validateAll().then((result) => {
                if(!result){
                    //console.log("ERROR" + result)
                    return;
                }
                this.signIn();
            }).catch(() => {
                // catches the error;
            });
        },
        signIn() {
            this.signin_value = 'Please Wait ...';
            let email = this.email
            let password = this.password
            this.$store.dispatch('login', { email, password })
            .then((resp) => {

                if(this.$store.state.mfa_status == 'success') {
                    axios('/custom/generate-myprofile-auth-code',
                    {
                        method: 'GET', 
                        params: { 
                          "email": this.$store.state.mfa_email,
                        }
                    })
                    .then(response => {                
                        this.navigate("/mmauthverify");
                    })
                    .catch(error => {

                    });





                }else {
                    document.body.className = '';
                    this.signin_value = 'Log In';
                    let msg = '';
                    let status = 'danger';
                    this.$store.dispatch('set_flash_msg', { msg, status})
                    if(resp.data.buttonColorCode) {
                        document.documentElement.style.setProperty('--main-bg-color', resp.data.buttonColorCode);
                        Vue.prototype.$logoName = resp.data.logoName;
                    }
                    else {
                        document.documentElement.style.setProperty('--main-bg-color', '#00ACEE');
                    }
                    if(resp.data.logoName) {
                        Vue.prototype.$logoName = resp.data.logoName;
                    }
                    else {
                        Vue.prototype.$logoName = 'MM-logo.png';
                    }
                    
                    if(resp.data.sign_count == 1) {
                        this.$store.dispatch('introduction_template_display', 1);
                    }
                    this.userRedirection();
                }


            })
            .catch(err => {
                this.signin_value = 'Log In';
                if(this.$store.state.status == 'error') {
                    this.login_errors = this.$store.state.err_message;
                }
            })
        },
        navigate(path) {
            router.push(path);
        },
        isInArray(value, array) {
            return array.indexOf(value) > -1;
        },
        userRedirect: function(role) {
            var url = '';
            if(role == 'Manager') {
                url = "/company-admin-dashboard";
            }
            else if(role == 'Mentor') {
                url = "/mentees-tasks-list";
            }
            else if(role == 'Primary Admin') {
                url = "/school-admin-dashboard";
            }
            else if(role == 'Instructor') {
                url = "/students-tasks-list";
            }
            return url;
        },
        userRedirection: function() {
            this.roles = this.$store.state.roles;
            if(this.roles) {
                this.admin_role_flag = this.isInArray('ROLE_MASTER_ADMIN', this.roles);
                this.researcher_role_flag = this.isInArray('ROLE_RESEARCHER', this.roles);
                this.csr_role_flag = this.isInArray('ROLE_CSR', this.roles);
                this.enterprise_admin_role_flag = this.isInArray('ROLE_ENTERPRISE_ADMIN', this.roles);
                if (this.admin_role_flag) {
                    this.navigate("/admin-dashboard");
                }
                else if (this.researcher_role_flag == true) {
                    this.navigate("/researcher-dashboard");
                } 
                else if (this.csr_role_flag == true) {
                    this.navigate("/csr-dashboard");
                } 
                else if(this.enterprise_admin_role_flag === true) {
                    this.getEnterpriseAdminInfo();
                } else {
                    this.getUserLinkedLocations();
                }
            }
        },
        openSuccessModal() {
            this.isSuccessModalVisible = true;
        },
        getUserLinkedLocations() {
            axios.get('/user/linked-locations', {
            })
            .then(response =>  {
                this.locations = response.data;
                this.locationsCount = this.locations.length;
                this.userAccounts.isUserLinkedMultipleLocations = false;
                this.userAccounts.locations = this.locations;
                if (this.locationsCount > 1) {
                    this.userAccounts.isUserLinkedMultipleLocations = true;
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    this.navigate('/user/select-location');
                } else if (this.locationsCount == 0) {
                    this.signin_value = 'Log In';
                    this.login_errors = 'User is not activated. Please contact administrator.';
                    this.$store.dispatch('logout');
                } else {
                    this.$store.dispatch('set_user_accountid', this.userAccounts.locations[0].accId);
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    this.roleBasedRedirection();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        roleBasedRedirection() {
            if (this.roles) {
                this.manager_role_flag = this.isInArray('ROLE_ADMIN', this.roles);
                this.mentor_role_flag = this.isInArray('ROLE_MENTOR', this.roles);
                this.mentee_role_flag = this.isInArray('ROLE_MENTEE', this.roles);
                this.apprentice_role_flag = this.isInArray('ROLE_APPRENTICE', this.roles);
                this.instructor_role_flag = this.isInArray('ROLE_INSTRUCTOR', this.roles);
                this.student_role_flag = this.isInArray('ROLE_STUDENT', this.roles);
                if(this.$store.state.switch_flag) {
                    var url = this.userRedirect(this.$store.state.switch_flag);
                    this.navigate(url);
                }
                else if(this.manager_role_flag === true) {
                    if(this.$store.state.school_flag == 1) {
                        this.navigate("/school-admin-dashboard");
                    }
                    else {
                        this.navigate("/company-admin-dashboard");
                    }
                }
                else if(this.mentor_role_flag === true) {
                    // this.navigate("/mentees-tasks-list");
                    this.navigate("/mentor-dashboard");
                }
                else if(this.mentee_role_flag === true) {
                    this.navigate("/mentee-dashboard");
                }
                else if(this.apprentice_role_flag === true) {
                    this.navigate("/apprentice-dashboard");
                }
                else if(this.instructor_role_flag === true) {
                    this.navigate("/students-tasks-list");
                }
                else if(this.student_role_flag === true) {
                    this.navigate("/student-dashboard");
                }
            }
        },
        getEnterpriseAdminInfo() {
            axios('/enterprise-admin-info-accountid',
            {
                method: 'GET',
            })
            .then(resp => {
                if(resp.data.account.userAccountStatus != 'Active') {
                    this.signin_value = 'Log In';
                    this.login_errors = 'User is not activated. Please contact administrator.';
                    this.$store.dispatch('logout');
                }
                else {
                    this.$store.dispatch('set_enterprise_type', resp.data.account.enterprise_type);
                    this.$store.dispatch('set_user_accountid', resp.data.account.id);
                    this.navigate("/enterprise-admin-dashboard");
                }
            })
            .catch(() => {
            });
        }
    },
    created: function() {
        document.body.className = 'login-page';
        this.$store.dispatch('clear_user_locations');
        this.userRedirection();
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/mm_login.vue